<ion-col size="12" size-md="auto">
  <!-- Refresh Icon -->
<!-- wrapped so we can add spacing below the refresh button -->
<div class="refresh-container">
  <span class="ml-5 fs-20 material-icons btn-reset"
        [class.clicked]="isClicked"
        style="cursor:pointer;"
        (click)="resetGrid()"
        (animationend)="isClicked = false">
    refresh
  </span>
</div>

<ag-grid-angular class="ag-theme-quartz" style="width: 100%; height: 680px;" [gridOptions]="gridOptions"
  [rowData]="mapData" [columnDefs]="columnDefs" [masterDetail]="true"
  [detailCellRendererParams]="gridOptions.detailCellRendererParams" (gridReady)="onGridReady($event)" layout="auto-height"  [popupParent]="document.body" [pagination]="pagination"
  [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector">
</ag-grid-angular>
</ion-col>
